import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../services/AppContext';
import styles from './LoginModal.module.css';

export function LoginModal({ isOpen, onClose }) {
	const { setUserLoggedIn } = useContext(AppContext);
	const [email, setEmail] = useState('');
	const supportEmail = 'publications@calhospital.org';
	const subject = 'Problem signing into the CHA Publications App';
	if (!isOpen) {
		return null;
	}
	const onSubmit = (e) => {
		e.preventDefault();
		isEmailValidDomain(email)
			.then((isValid) => {
				if (isValid) {
					setEmail('');
					onClose();
					alert('User authenticated successfully');
					localStorage.setItem('is-user-login', '1');
					setUserLoggedIn(true);
					return;
				}

				setUserLoggedIn(false);
				alert('Invalid account');
				setEmail('');
			})
			.catch((err) => {
				console.error(err);
				alert(err.message);
			});
	};
	return (
		<dialog className={styles['login-dialog']} open>
			<form method="dialog" onSubmit={onSubmit}>
				<div className={styles['image']}>
					<h1>Sign In</h1>
					<p>Please login to access this policy</p>
				</div>
				<section className={styles['content']}>
					<input
						type="email"
						placeholder="Email"
						value={email}
						onChange={(e) => {
							const { value } = e.target;
							setEmail(value.toLowerCase());
						}}
					/>
					<small>
						<a href={`mailto:${supportEmail}?subject=${subject}`}>
							Problems signing in?
						</a>
					</small>
				</section>
				<section className={styles['actions']}>
					{isValidEmail(email) ? (
						<button type="submit">Login</button>
					) : (
						<button disabled type="submit">
							Login
						</button>
					)}

					<button onClick={onClose} type="button">
						Cancel
					</button>
				</section>
			</form>
		</dialog>
	);
}

LoginModal.propTypes = {
	isOpen: PropTypes.any,
	onClose: PropTypes.func,
};

function isValidEmail(email) {
	if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email)) {
		return true;
	}
	return false;
}

async function getDomainData() {
	const res = await fetch('/data.json');
	const { domain } = await res.json();
	return new Set([...domain]);
}

async function isEmailValidDomain(email) {
	if (email.split('@').length !== 2) {
		return false;
	}
	const domain = email.split('@')[1];
	const data = await getDomainData();
	return data.has(domain);
}
